var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0939 3.19637L12.6236 5.72606M8.40743 15.0016H15.1533M1.66159 11.6287L0.818359 15.0016L4.19128 14.1584L13.9609 4.3887C14.2771 4.07244 14.4547 3.64356 14.4547 3.19637C14.4547 2.74918 14.2771 2.3203 13.9609 2.00404L13.8159 1.85901C13.4997 1.54284 13.0708 1.36523 12.6236 1.36523C12.1764 1.36523 11.7475 1.54284 11.4313 1.85901L1.66159 11.6287Z",
    stroke: "#F7F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenWhite);
export default __webpack_public_path__ + "static/media/pen-white.346cd68526c5300f49d222d524681ef5.svg";
export { ForwardRef as ReactComponent };